module.exports = __webpack_public_path__ + "static/img/xiaochengxu.845f892.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xiaochengxu.jpg
// module id = 3ZNt
// module chunks = 128